import React, {Component} from 'react';
import classNames from 'classnames';
import FJUtil from "../../../util/FJUtil";
// import FJCoreConfig from '../../../core/FJCoreConfig'
import InlineSVG from "react-inlinesvg";
import FJFontItem from './FJFontItem';
// import FJTriangleIcon from '../../../icon/FJTriangleIcon.svg';
import ArrowDown from '../../../icon/arrow-dowm.svg'

import './FJFontCategory.less';
import FJConfig from "../../../config/FJConfig";

class FJFontCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: false,
        };
        this.categoryHandle = React.createRef();
    }
    componentDidMount() {
       FJUtil.rippleAnimationLite(this.categoryHandle.current, {duration: FJConfig.ripple.duration, color: FJConfig.ripple.color, multi: true});
    }
    componentDidUpdate(preProps, preState) {
        if (preState.active !== this.state.active) {
            if (this.state.active) {
                if (this.props.showCallback) {
                    this.props.showCallback(this.categoryHandle.current);
                }
            } else {
                if (this.props.hideCallback) {
                    this.props.hideCallback();
                }
            }
        }
    }

    active = (toggle) => {
        if (typeof toggle === 'undefined') {
            return this.state.active;
        } else {
            this.setState({
                active: toggle,
            });
            return toggle;
        }
    };

    _toggleActive = () => {
        this.setState((preState) => {
            return {
                active: !preState.active,
            }
        });
    };
    _getComps = () => {
        let {fonts, activeFontName, loadingFonts} = this.props;
        return fonts.map((item) => {
            let name = item.name;
            let url = item.path + `?v=${FJConfig.version}`;
            let active = name && activeFontName && (name.toLowerCase() === activeFontName.toLowerCase());
            return <FJFontItem loadingFonts={loadingFonts} active={active} dataChange={this._dataChange} url={url} key={name} fontName={name}/>
        });
    };

    _dataChange = (data) => {
        this.props.dataChange(data);
    };

    render() {
        let {icon} = this.props;
        let categoryClass = classNames('c-font-category-container', {active: this.state.active});
        return (
            <div className={categoryClass}>
                <div onClick={this._toggleActive}
                     ref={this.categoryHandle}
                     className='u-button-cursor c-font-category'>
                    <div className='c-font-category__preview'>
                        {icon}
                    </div>
                    <InlineSVG src={ArrowDown} element='div' />
                </div>
                <ul className='c-font-list'>
                    {this._getComps()}
                </ul>
            </div>
        );
    }
}

export default FJFontCategory;
